/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import {
  AppServiceMachineType,
  AppServiceRequestProcessor,
} from "../../state-machine";
import config from "../config/activityList.config.json";
import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IActivityListMethods extends IPluginMethodMap {
  getActivityListProps(args: any): Promise<any>;
}

export class ActivityListService
  extends AppServiceRequestProcessor
  implements IAgentPlugin
{
  readonly methods: IActivityListMethods;

  constructor() {
    super();
    this.methods = {
      getActivityListProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_DASHBOARD_ANALYTICS_QUERY,
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data?.getDashBoardAnalytics) {

    //     }
    //   }
    // } catch (err: any) {
    //   console.log(`error in getDashboardQuery`, err);
    //   throw Error(err?.message);
    // }

    return {
      tableData: config,
    };
  }
}
